<template>
  <div class="sd-layers-collapse-card">
    <div class="map-switch__layers-wrap" v-if="selectItem_ && baseLayerInfos.length > 0">
      <sd-fold-cards :data="baseLayerInfos" :defaultItem="selectItem_" @click="clickItem"></sd-fold-cards>
    </div>
  </div>
</template>

<script>
/**
 * @description 基础地图组件
 * @author GuoYun
 */
export default {
  name: 'SdBaseLayers',
  data() {
    return {
      mapCtrl_: null,
      mouseEnter_: false,
      selectItem_: null,
    }
  },
  props: {
    baseLayerInfos: {
      type: Array,
      default() {
        return []
      },
    },
    showLabel:{
      type:Boolean,
      default:true
    }
  },
  created() {
    this.initBaseLayers()
  },
  beforeDestroy() {
    this.baseLayerInfos.forEach((baseLayerInfo) => {
      this.mapCtrl_.removeLayerByName(baseLayerInfo.name, true)
    })
  },
  watch:{
    showLabel(){
      this.selectLayer()
    }
  },
  methods: {
    initBaseLayers() {
      this.baseLayerInfos.forEach((baseLayerInfo) => {
        if (baseLayerInfo.select) {
          this.selectItem_ = baseLayerInfo
        }
      })
      this.baseLayerInfos.forEach((baseLayerInfo) => {
        if (baseLayerInfo.selected) {
          this.selectItem_ = baseLayerInfo
        }
      })
      if (!this.selectItem_ && this.baseLayerInfos.length > 0) {
        this.selectItem_ = this.baseLayerInfos[0]
      }
    },
    /**
     * 初始化控件，地图控件会调用该方法进行地图初始化
     * @param {Map} map  open layer 地图控件
     */
    setMap(map, mapCtrl) {
      this.mapCtrl_ = mapCtrl
      this.addBaseLayers()
      if (this.selectItem_) {
        this.clickItem(this.selectItem_)
      }
      
    },
    selectByName(name){
      if(this.selectItem_.name===name) return
      const item = this.baseLayerInfos.find(i=>i.name = name)
      item && this.clickItem(item)
    },
    mouseChange(isEnter) {
      this.mouseEnter_ = isEnter
    },
    clickItem(item) {
      this.selectItem_ = item
      this.selectLayer()
    },
    addBaseLayers() {
      this.baseLayerInfos.forEach((layerInfo) => {
        var layers = layerInfo.layers instanceof Array ? layerInfo.layers : [layerInfo.layers]
        layers.forEach((layer) => {
          layer.setVisible(false)
          this.mapCtrl_.addLayer(layerInfo.name, layer, true, true)
        })
      })
    },
    selectLayer() {
      this.selectItem_ && this.mapCtrl_.changeBaseLayerVisible(this.selectItem_.name,this.showLabel)
    },
  },
}
</script>

<style scoped>
.sd-layers-collapse-card {
  position: absolute;
  right: 0px;
  bottom: 0px;
  z-index: 10;
}
.map-switch__layers-wrap {
  position: absolute;
  bottom: 30px;
  right: -10px;
}
</style>
